import React from 'react'
import './Signature.css'
import PropTypes from 'prop-types'
import SignPad from './SignPad'
//MUI
import AddIcon from '@material-ui/icons/Add'
import GetAppIcon from '@material-ui/icons/GetApp'
import DeleteIcon from '@material-ui/icons/Delete'
//Redux
import { deleteSketch } from '../../../redux'
import { useDispatch, useSelector } from 'react-redux'
function SketchManager(props) {
  const { addSignature } = props
  const dispatch = useDispatch()
  const sketch = useSelector((state) => state.sketch)

  const handleDownloadSketch = (trimmedDataURL) => {
    var a = document.createElement('a') //Create <a>
    a.href = trimmedDataURL //Image Base64 Goes here
    a.download = 'transparent signature.png' //File name Here
    a.click() //Downloaded file
  }

  const handleDeleteSketch = (trimmedDataURL) => {
    dispatch(deleteSketch(trimmedDataURL))
  }

  let signPadMarkup = sketch.isModalOpen ? <SignPad /> : null

  let sketchMarkup =
    sketch.sketches.length > 0 ? (
      <div className='sketch-container '>
        <p className='no-select sketch-title'>Signature Sketch</p>
        <div className='sketch-collection'>
          {sketch.sketches.map((sketch, index) => {
            return (
              <div className='sketch-sample' key={index}>
                <img src={sketch} alt='pic' width='100%' height='100%' />
                <div className='sketch-sample-icon-container'>
                  <div className='sketch-sample-icon' onClick={() => addSignature(sketch)}>
                    <AddIcon />
                  </div>
                  <div className='sketch-sample-icon' onClick={() => handleDownloadSketch(sketch)}>
                    <GetAppIcon />
                  </div>
                  <div className='sketch-sample-icon' onClick={() => handleDeleteSketch(sketch)}>
                    <DeleteIcon />
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    ) : (
      <p className='no-select sketch-placeholder'>You do not have any sketch sketch now.</p>
    )

  return (
    <>
      {signPadMarkup}
      {sketchMarkup}
    </>
  )
}

SketchManager.propTypes = {
  addSignature: PropTypes.func.isRequired,
}
export default SketchManager
